import { render, staticRenderFns } from "./brnnTable.vue?vue&type=template&id=923c6a78&scoped=true"
import script from "./brnnTable.vue?vue&type=script&lang=ts"
export * from "./brnnTable.vue?vue&type=script&lang=ts"
import style0 from "./brnnTable.vue?vue&type=style&index=0&id=923c6a78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923c6a78",
  null
  
)

export default component.exports